"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteKind = void 0;
var InviteKind;
(function (InviteKind) {
    InviteKind["All"] = "all";
    InviteKind["Platform"] = "platform";
    InviteKind["Ritual"] = "ritual";
})(InviteKind = exports.InviteKind || (exports.InviteKind = {}));
